export default __webpack_public_path__ + "static/media/icon_LAS.700f2331.svg";